import { ContainerItemAware } from "../../container-view/models/containerItem-aware";
import { LabMDM } from "../../masterdata/models/lab";
import { Carrier } from "../../carrier/carrier";
import { LiquidLevelDetectionResponse } from "../liquid-level-detection-response";

export class NGSUpdateSampleRequestResponse {

    ngsMeasurementResponse: LiquidLevelDetectionResponse;
    carrierList: Carrier[];
    sampleList: ContainerItemAware[];
    lab: LabMDM;
}